import {FormDrawer} from "./FormDrawer.tsx";
import {DrawerProps} from "@mantine/core";
import {Playbook} from "../types.ts";
import {usePlaybook} from "../hooks/usePlaybook.ts";


export const AddFormDrawer = (props: DrawerProps) => {


    const {
        record,
        createRecord,
    } = usePlaybook();

    return (
        <FormDrawer
            record={record ?? {} as Playbook}
            handleSubmit={createRecord}
            {...props}
        />
    )
};


